import Loadable from '@townsquare/loadable';
import {
	agentEmbedRoute,
	createKudosEmbedRoute,
	createKudosEmbedRouteOld,
	goalEmbedRoute,
	goalsDirectoryEmbedRoute,
	labelEmbedRoute,
	projectEmbedRoute,
	projectsDirectoryEmbedRoute,
	teamEmbedRoute,
} from '@townsquare/routes/embeds';

import { createKudosResource } from './resources/createKudosResource';
import { goalEmbedResource } from './resources/goalEmbedResource';
import { goalsDirectoryEmbedResource } from './resources/goalsDirectoryEmbedResource';
import { labelEmbedResource } from './resources/labelResource';
import { projectEmbedResource } from './resources/projectEmbedResource';
import { projectsDirectoryEmbedResource } from './resources/projectsDirectoryEmbedResource';

const GoalEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "GoalEmbed" */ './components/Goal/GoalEmbed'),
	loading: () => null,
});

goalEmbedRoute.component = GoalEmbed;
goalEmbedRoute.resources = [goalEmbedResource];
export const goalEmbedRouterRoute = goalEmbedRoute;

const ProjectEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "ProjectEmbed" */ './components/Project/ProjectEmbed'),
	loading: () => null,
});

projectEmbedRoute.component = ProjectEmbed;
projectEmbedRoute.resources = [projectEmbedResource];
export const projectEmbedRouterRoute = projectEmbedRoute;

const GoalsDirectoryEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "GoalsDirectoryEmbed" */ './components/GoalsDirectory/GoalsDirectoryEmbed'),
	loading: () => null,
});
goalsDirectoryEmbedRoute.component = GoalsDirectoryEmbed;
goalsDirectoryEmbedRoute.resources = [goalsDirectoryEmbedResource];
export const goalsDirectoryEmbedRouterRoute = goalsDirectoryEmbedRoute;

const ProjectsDirectoryEmbed = Loadable({
	loader: () =>
		import(/* webpackChunkName: "ProjectsDirectoryEmbed" */ './components/ProjectsDirectory/ProjectsDirectoryEmbed'),
	loading: () => null,
});
projectsDirectoryEmbedRoute.component = ProjectsDirectoryEmbed;
projectsDirectoryEmbedRoute.resources = [projectsDirectoryEmbedResource];
export const projectsDirectoryEmbedRouterRoute = projectsDirectoryEmbedRoute;

const LabelEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "LabelEmbed" */ './components/Label/LabelEmbed'),
	loading: () => null,
});
labelEmbedRoute.component = LabelEmbed;
labelEmbedRoute.resources = [labelEmbedResource];
export const labelEmbedRouterRoute = labelEmbedRoute;

const KudosEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "CreateKudosEmbed" */ './components/Kudos/CreateKudosEmbed'),
	loading: () => null,
});
createKudosEmbedRouteOld.component = KudosEmbed;
createKudosEmbedRouteOld.resources = [createKudosResource];
export const createKudosEmbedRouterRouteOld = createKudosEmbedRouteOld;

createKudosEmbedRoute.component = KudosEmbed;
createKudosEmbedRoute.resources = [createKudosResource];
export const createKudosEmbedRouterRoute = createKudosEmbedRoute;

const AgentEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "AgentEmbed" */ './components/Agent/AgentEmbed'),
	loading: () => null,
});
agentEmbedRoute.component = AgentEmbed;
export const agentEmbedRouterRoute = agentEmbedRoute;

const TeamEmbed = Loadable({
	loader: () => import(/* webpackChunkName: "TeamEmbed" */ './components/Team/TeamEmbed'),
	loading: () => null,
});
teamEmbedRoute.component = TeamEmbed;
export const teamEmbedRouterRoute = teamEmbedRoute;
